import { AnimatePresence, motion } from 'motion/react'
import { CustomerAreaSurfaceCard, customerMotionTransition } from '../customer-area'
import { ChevronRightIcon, QuickActionItem, QuickActionsSkeleton } from './dashboardShared'

type DashboardQuickActionsSectionProps = {
  isBootstrapLoading: boolean
  reducedMotion: boolean
  quickActionCards: QuickActionItem[]
  isItalian: boolean
}

export const DashboardQuickActionsSection = ({
  isBootstrapLoading,
  reducedMotion,
  quickActionCards,
  isItalian,
}: DashboardQuickActionsSectionProps) => (
  <CustomerAreaSurfaceCard
    title={isItalian ? 'Azioni rapide' : 'Quick actions'}
    subtitle={
      isItalian
        ? 'Accesso immediato alle attivita principali del tuo account cliente.'
        : 'Immediate access to the most important customer account tasks.'
    }
  >
    <AnimatePresence mode="wait" initial={false}>
      {isBootstrapLoading ? (
        <motion.div
          key="quick-actions-skeleton"
          initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
          animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
          exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
          transition={customerMotionTransition}
        >
          <QuickActionsSkeleton />
        </motion.div>
      ) : (
        <motion.div
          key="quick-actions-content"
          initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
          animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
          exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
          transition={customerMotionTransition}
          className="grid gap-3 md:grid-cols-2 xl:grid-cols-4"
        >
          {quickActionCards.map((action) => (
            <motion.button
              key={action.id}
              type="button"
              onClick={action.onClick}
              whileHover={reducedMotion ? undefined : { y: -2 }}
              whileTap={reducedMotion ? undefined : { scale: 0.99 }}
              transition={customerMotionTransition}
              className="ca-card-shell ca-theme-transition group relative rounded-xl px-4 py-3 text-left transition-all duration-200 ease-out hover:-translate-y-0.5 hover:scale-[1.01] hover:border-(--color-border-strong) hover:shadow-(--shadow-md) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color-mix(in_srgb,var(--color-focus-ring)_40%,transparent)]"
            >
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-(--color-border-strong) bg-(--color-bg-surface-muted) text-(--color-text-secondary) transition-colors duration-200 ease-out group-hover:border-(--color-border-strong) group-hover:bg-(--color-bg-page-secondary) group-hover:text-(--color-text-primary)">
                {action.icon}
              </span>
              <p className="mt-3 text-sm font-semibold text-(--color-text-primary)">{action.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-(--color-text-secondary)">{action.description}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-(--color-text-secondary) transition-colors duration-200 ease-out group-hover:text-(--color-text-primary)">
                {isItalian ? 'Apri' : 'Open'}
                <ChevronRightIcon className="h-3.5 w-3.5" />
              </span>
            </motion.button>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  </CustomerAreaSurfaceCard>
)
